import { Link } from '@inertiajs/react';
import { Confirm } from '../confirm';

export function ActionHandler({
  to,
  method,
  as: Component = 'button',
  type,
  href,
  onClick,
  children,
  confirm,
  target,
  data = {},
  disabled = false,
  className
}) {
  if (disabled) {
    return (
      <span className={`inline-flex opacity-50 pointer-events-none select-none ${className}`}>
        {children}
      </span>
    );
  }

  if (confirm) {
    return <Confirm {...confirm}>{children}</Confirm>;
  }

  const getDataAttributes = data => {
    return Object.entries(data).reduce((acc, [key, value]) => {
      // Check if key starts with 'turbo'
      if (key.startsWith('turbo')) {
        // Convert turbo_frame to data-turbo-frame format
        const formattedKey = `data-${key.replace(/_/g, '-')}`;
        acc[formattedKey] = value;
      }
      return acc;
    }, {});
  };

  const dataAttributes = getDataAttributes(data);
  const hasTurboAttributes = Object.keys(data).some(key => key.startsWith('turbo'));

  if (href && (target || hasTurboAttributes)) {
    return (
      <a className={`${className} cursor-pointer`} href={href} target={target} {...dataAttributes}>
        {children}
      </a>
    );
  }

  if (href) {
    return (
      <Link className={`${className} cursor-pointer`} href={href} type={type} method={method}>
        {children}
      </Link>
    );
  }

  return (
    <Component
      {...dataAttributes}
      onClick={onClick}
      type={type}
      className={`${className} cursor-pointer`}
    >
      {children}
    </Component>
  );
}
